import { apiGet } from './api'
import { mergeOrdersWithLocalLabs } from './labOrders'

const MSO_ORDERS_CHANGED_EVENT = 'kis-rx-mso-orders-changed'
const LEGACY_LAB_ORDERS_CHANGED_EVENT = 'kis-rx-lab-orders-changed'

export async function fetchMsoOrders() {
  const data = await apiGet('/api/mso/orders')
  return mergeOrdersWithLocalLabs(data.orders || [])
}

export function broadcastMsoOrdersChanged(detail = {}) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(MSO_ORDERS_CHANGED_EVENT, {
    detail: {
      ...detail,
      at: new Date().toISOString(),
    },
  }))
}

export function subscribeMsoOrdersChanged(handler) {
  if (typeof window === 'undefined') return () => {}
  const wrapped = event => handler(event)
  window.addEventListener(MSO_ORDERS_CHANGED_EVENT, wrapped)
  window.addEventListener(LEGACY_LAB_ORDERS_CHANGED_EVENT, wrapped)
  return () => {
    window.removeEventListener(MSO_ORDERS_CHANGED_EVENT, wrapped)
    window.removeEventListener(LEGACY_LAB_ORDERS_CHANGED_EVENT, wrapped)
  }
}
